module.exports = __webpack_public_path__ + "components/breakheader/background/background--6-bf022346aa9b5f93b695d502ec425901.jpg";